export default "__VITE_ASSET__DGP6wH9s__"